"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var util_1 = require("@aperza/util");
var AcTableHeaderCell_1 = require("./AcTableHeaderCell");
var AcTableSelectorHeaderCell_1 = require("./AcTableSelectorHeaderCell");
var AcActionDropdown_1 = require("../dropdown/AcActionDropdown");
exports.AcTableHeader = function (props) {
    var _a = props.columns, columns = _a === void 0 ? [] : _a, pageSize = props.pageSize, onSort = props.onSort, sorts = props.sorts, onSelectPageSize = props.onSelectPageSize;
    var getSort = function (sorts, column, columnIndex) {
        if (!sorts || util_1.ArrayUtil.isEmpty(sorts))
            return undefined;
        var selectedSort = sorts.find(function (sort) {
            if (Array.isArray(sort) && sort.length >= 2) {
                var columnId = sort[0];
                if (columnId === column.name ||
                    (Array.isArray(column.name) && column.name.includes(columnId)) ||
                    parseInt(columnId, 10) === columnIndex) {
                    return true;
                }
            }
            return false;
        });
        if (selectedSort) {
            return selectedSort;
        }
        return undefined;
    };
    var onSelectAll = function (checked) {
        if (props.onSelectAll) {
            props.onSelectAll(checked);
        }
    };
    var updatePageSize = function (_pageSize) {
        if (onSelectPageSize)
            onSelectPageSize(_pageSize);
    };
    var pageSizeActionDropdownProps = function () {
        return {
            id: 'pagesize_dropdown',
            size: 'sm',
            dropdownClassName: 'p-0',
            menuMinWidth: '70px',
            title: function () {
                return react_1.default.createElement("span", { className: "font-weight-bold text-body" }, pageSize + "\u4EF6");
            },
            actions: [
                {
                    name: 'pagesize_10',
                    title: function () {
                        return react_1.default.createElement("span", { className: "d-block text-center p-1 fs-11" }, "10\u4EF6");
                    },
                    onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            updatePageSize(10);
                            return [2 /*return*/];
                        });
                    }); },
                },
                {
                    name: 'pagesize_30',
                    title: function () {
                        return react_1.default.createElement("span", { className: "d-block text-center p-1 fs-11" }, "30\u4EF6");
                    },
                    onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            updatePageSize(30);
                            return [2 /*return*/];
                        });
                    }); },
                },
                {
                    name: 'pagesize_50',
                    title: function () {
                        return react_1.default.createElement("span", { className: "d-block text-center p-1 fs-11" }, "50\u4EF6");
                    },
                    onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            updatePageSize(50);
                            return [2 /*return*/];
                        });
                    }); },
                },
            ],
        };
    };
    var headerCols = columns
        .filter(function (column) { return column.display; })
        .map(function (column, index) {
        if (column.pageSizeDropdown) {
            return (react_1.default.createElement("th", { className: "text-nowrap", style: { color: '#2f5d8a' }, key: index },
                react_1.default.createElement("div", { className: "d-flex flex-row flex-nowrap align-items-center justify-content-end" },
                    react_1.default.createElement("span", null, "\u8868\u793A\u4EF6\u6570\uFF1A"),
                    react_1.default.createElement(AcActionDropdown_1.AcActionDropdown, __assign({}, pageSizeActionDropdownProps(), { data: {}, alignRight: true })))));
        }
        if (column.selector) {
            return react_1.default.createElement(AcTableSelectorHeaderCell_1.AcTableSelectorHeaderCell, { key: index, onSelectAll: onSelectAll });
        }
        var sort = getSort(sorts, column, index);
        return (react_1.default.createElement(AcTableHeaderCell_1.AcTableHeaderCell, { key: index, columnIndex: index, column: column, sortFieldName: sort === null || sort === void 0 ? void 0 : sort[0], sortDirection: sort === null || sort === void 0 ? void 0 : sort[1], onSort: onSort }));
    });
    return (react_1.default.createElement("thead", null,
        react_1.default.createElement("tr", null, headerCols)));
};
exports.AcTableHeader.displayName = 'AcTableHeader';
//# sourceMappingURL=AcTableHeader.js.map